module.exports = {
    // base_url: 'https://indonesia40-api.intellivent.id/',
    base_url: 'https://fordigi2023-api.intellivent.id/',
    // base_url: 'https://indonesia40dev-api.intellivent.id/',
};